import React, { PropsWithChildren, useEffect, useMemo } from 'react';
import { ThemeProvider } from '@mui/material';
import getCustomTheme from 'src/components/theme';
import { useAppSettings } from 'src/hooks/useAppSettings';
import { useDocumentTitle, useFavicon } from '@siberiacancode/reactuse';

export const AppSettingsAndThemeProvider = ({
  children,
}: PropsWithChildren) => {
  const { data } = useAppSettings();
  const { set: setTitle } = useDocumentTitle();
  const { set: setFavicon } = useFavicon();

  useEffect(() => {
    if (data?.assets.favicon) setFavicon(data.assets.favicon);
  }, [data?.assets.favicon, setFavicon]);

  useEffect(() => {
    if (data?.title) setTitle(`${data.title}: Админка`);
  }, [data?.title, setTitle]);

  const customTheme = useMemo(
    () => getCustomTheme(data?.theme.primaryColor),
    [data?.theme.primaryColor]
  );

  return <ThemeProvider theme={customTheme}>{children}</ThemeProvider>;
};
